import {
    Button,
    IconButton,
    MenuItem,
    Select,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SearchBar from "../../../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import AddPolicy from "../../../../Modals/addPolicy";

const ViewPolicies = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openModal, setOpenModal] = useState(false);

    const handleCloseModal = () => setOpenModal(false);

    const policyDetails = {
        id: "POL-SEC",
        title: "Information Security Policy",
        description:
            "Enterprise wide security controls and requirements governing data protection and access.",
        category: "Security",
        owner: "Michael Roberts",
        status: "Active",
        effectiveDate: "1/15/2024",
        reviewDate: "1/15/2025",
        icon: <SecurityOutlinedIcon />,

        versions: [
            {
                id: "POL-SEC-001",
                version: "v3.0",
                description: "Updated encryption standards and incident response flow",
                dateAdded: "15 Jan 2024",
                status: "Active",
            },
            {
                id: "POL-SEC-002",
                version: "v2.0",
                description: "Added MFA enforcement and vendor access controls",
                dateAdded: "10 Jun 2023",
                status: "Active",
            },
            {
                id: "POL-SEC-003",
                version: "v1.0",
                description: "Initial security policy baseline",
                dateAdded: "01 Feb 2022",
                status: "Archived",
            },
        ],
    };

    return (
        <>
            {/* ================= HEADER ================= */}
            <div className="main_title">
                <h1>Policy Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/compliance-policies")}>
                        Compliance Policies
                    </button>{" "}
                    - Policy Details
                </p>
            </div>

            {/* ================= MAIN POLICY ================= */}
            <div className="cards">
                <div className="view_page">
                    <div className="gap_p">

                        <div className="w_33">
                            <h6>Policy ID</h6>
                            <p>{policyDetails.id}</p>
                        </div>

                        <div className="w_33">
                            <h6>Title</h6>
                            <p>{policyDetails.title}</p>
                        </div>

                        <div className="w_33">
                            <h6>Category</h6>
                            <p>{policyDetails.category}</p>
                        </div>

                        <div className="w_33">
                            <h6>Status</h6>
                            <p>{policyDetails.status}</p>
                        </div>

                        <div className="w_33">
                            <h6>Policy Owner</h6>
                            <p>{policyDetails.owner}</p>
                        </div>

                        <div className="w_33">
                            <h6>Effective Date</h6>
                            <p>{policyDetails.effectiveDate}</p>
                        </div>

                        <div className="w_33">
                            <h6>Review Date</h6>
                            <p>{policyDetails.reviewDate}</p>
                        </div>

                        <div className="w_33">
                            <h6>Description</h6>
                            <p>{policyDetails.description}</p>
                        </div>

                    </div>
                </div>
            </div>

            {/* ================= POLICY VERSIONS ================= */}
            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search versions..."
                        />
                    </div>

                    <div className="right_s form">
                        <Select size="small" value="All">
                            <MenuItem value="All">All Status</MenuItem>
                            <MenuItem value="Active">Active</MenuItem>
                            <MenuItem value="Archived">Archived</MenuItem>
                        </Select>

                        <Button
                            className="btn btn_primary"
                            onClick={() => setOpenModal(true)}
                        >
                            <AddIcon /> Add
                        </Button>

                    </div>
                </div>

                <div className="policies_div mt_20">
                    {policyDetails.versions.map((ver, i) => (
                        <div className="policy_row" key={i}>
                            <div className="left">
                                <div className="policy_icon">
                                    {policyDetails.icon}
                                </div>

                                <div className="policy_info">
                                    <div className="title_row">
                                        <b>{policyDetails.title}</b>
                                        <span className="code">{ver.id}</span>

                                        <span className={`status_chip ${ver.status === "Active" ? "active" : "danger"}`}>
                                            {ver.status}
                                        </span>
                                    </div>

                                    <p>{ver.description}</p>

                                    <small>
                                        Version {ver.version} · Added on {ver.dateAdded}
                                    </small>
                                </div>
                            </div>

                            <div className="actions">
                                <IconButton onClick={() => setOpenModal(true)}>
                                    <EditOutlinedIcon />
                                </IconButton>
                                <IconButton>
                                    <DeleteOutlineOutlinedIcon />
                                </IconButton>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <AddPolicy
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default ViewPolicies;
